import React, {Component} from 'react'
import Text from './Field/Text'
import Email from './Field/Email'
import Password from './Field/Password'
import Textarea from './Field/Textarea'
import Number from './Field/Number'
import File from './Field/File'

export default class Field extends Component {
    setField(name, value, error) {
        this.props.setValue(name, value, error)
    }

    render() {
        if (this.props.type === 'email') {
            return (
                <Email
                    params={this.props}
                    setField={this.setField.bind(this)}
                    state={this.props.state}
                />
            );
        }
        if (this.props.type === 'text') {
            return (
                <Text
                    params={this.props}
                    setField={this.setField.bind(this)}
                    state={this.props.state}
                />
            );
        }
        if (this.props.type === 'textarea') {
            return (
                <Textarea
                    params={this.props}
                    setField={this.setField.bind(this)}
                    state={this.props.state}
                />
            );
        }
        if (this.props.type === 'password') {
            return (
                <Password
                    params={this.props}
                    setField={this.setField.bind(this)}
                    state={this.props.state}
                />
            );
        }
        if (this.props.type === 'number') {
            return (
                <Number
                    params={this.props}
                    setField={this.setField.bind(this)}
                    state={this.props.state}
                />
            );
        }
        if (this.props.type === 'file') {
            return (
                <File
                    params={this.props}
                    setField={this.setField.bind(this)}
                    state={this.props.state}
                />
            );
        }

        return (
            <div>No type</div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/common/Field.js